// Local translations
export const T = {
  en_GB: {
    text: "Text",
    number: "Number",
    dropdown: "Dropdown",
    textArea: "Text Area",
    date: "Date",
    datetime: "Date and time",
    email: "Email",
    phone: "Phone",
    radio: "Radio buttons",
    multiselect: "Multi-select (checkboxes)",
    boolean: "Checkbox (yes/no)",
    fieldNameRequired: "Field name is required",
    dropdownMustHaveOptions: "Option fields must have at least one option",
    optionLabelRequired: "Every option needs a label",
    failedToSaveField: "Failed to save field",
    editField: "Edit Field",
    createNewField: "Create New Field",
    editFieldDescription: "Update the field settings below.",
    createFieldDescription: "Define a new field for your flow.",
    fieldName: "Field Name",
    fieldNamePlaceholder: "e.g., Company Name, Date of Birth",
    fieldType: "Field Type",
    fieldTypeCannotChange: "Field type cannot be changed after creation",
    fieldScope: "Field Scope",
    globalScope: "Global (one value per flow)",
    goalScope: "Goal (one value per goal)",
    portfolioScope: "Portfolio (one value per portfolio)",
    globalScopeDescription: "This field will have the same value across the entire flow",
    goalScopeDescription: "This field will have a separate value for each investment goal",
    portfolioScopeDescription:
      "This field will have a separate value for each portfolio within a goal",
    fieldScopeCannotChange:
      "Field scope cannot be changed after creation. To use another scope, duplicate the field from the fields list.",
    options: "Options",
    addOption: "Add option",
    optionLabel: "Option",
    moveOptionUp: "Move option up",
    moveOptionDown: "Move option down",
    removeOption: "Remove option",
    optionEditHint: "Editing an option's text updates it everywhere it is already selected",
    requiredField: "Required Field",
    requiredFieldDescription: "Client must fill in this field to proceed",
    syncKey: "Sync key",
    syncKeyPlaceholder: "e.g. RISK_PROFILE",
    syncKeyDescription:
      "Identifier an integration uses for this field on the public API. Must be unique within the flow.",
    syncKeyInUse: "Sync key is already used by another field in this flow",
    optionModeLabel: "Label",
    optionModeSyncKey: "Sync key",
    optionModeAria: "Edit option labels or sync keys",
    optionSyncKeyDisabled:
      "Give the field a sync key first — options can only have sync keys when their field has one",
    optionSyncKeyPlaceholder: "e.g. HIGH",
    optionSyncKeyAria: "sync key",
    optionSyncKeyDescription:
      "Identifier an integration can send instead of the option id. Must be unique within this field.",
    optionSyncKeyInUse: "Another option of this field already uses this sync key",
    optionSyncKeysDropped:
      "The field has no sync key, so the options' sync keys will be removed when you save.",
    cancel: "Cancel",
    save: "Save",
    addField: "Add Field",
  },
  nb_NO: {
    text: "Tekst",
    number: "Tall",
    dropdown: "Nedtrekksmeny",
    textArea: "Tekstfelt",
    date: "Dato",
    datetime: "Dato og klokkeslett",
    email: "E-post",
    phone: "Telefon",
    radio: "Radioknapper",
    multiselect: "Flervalg (avkrysningsbokser)",
    boolean: "Avkrysningsboks (ja/nei)",
    fieldNameRequired: "Feltnavn er obligatorisk",
    dropdownMustHaveOptions: "Alternativfelt må ha minst ett alternativ",
    optionLabelRequired: "Alle alternativer må ha en tekst",
    failedToSaveField: "Kunne ikke lagre felt",
    editField: "Rediger felt",
    createNewField: "Opprett nytt felt",
    editFieldDescription: "Oppdater feltinnstillingene nedenfor.",
    createFieldDescription: "Definer et nytt felt for flyten din.",
    fieldName: "Feltnavn",
    fieldNamePlaceholder: "f.eks. Firmanavn, Fødselsdato",
    fieldType: "Felttype",
    fieldTypeCannotChange: "Felttype kan ikke endres etter opprettelse",
    fieldScope: "Feltomfang",
    globalScope: "Global (én verdi per flyt)",
    goalScope: "Mål (én verdi per mål)",
    portfolioScope: "Portefølje (én verdi per portefølje)",
    globalScopeDescription: "Dette feltet vil ha samme verdi i hele flyten",
    goalScopeDescription: "Dette feltet vil ha en egen verdi for hvert investeringsmål",
    portfolioScopeDescription:
      "Dette feltet vil ha en egen verdi for hver portefølje innenfor et mål",
    fieldScopeCannotChange:
      "Feltomfang kan ikke endres etter opprettelse. For å bruke et annet omfang, dupliser feltet fra feltlisten.",
    options: "Alternativer",
    addOption: "Legg til alternativ",
    optionLabel: "Alternativ",
    moveOptionUp: "Flytt alternativet opp",
    moveOptionDown: "Flytt alternativet ned",
    removeOption: "Fjern alternativ",
    optionEditHint:
      "Endrer du teksten på et alternativ, oppdateres den overalt der det allerede er valgt",
    requiredField: "Obligatorisk felt",
    requiredFieldDescription: "Kunden må fylle ut dette feltet for å fortsette",
    syncKey: "Synkroniseringsnøkkel",
    syncKeyPlaceholder: "f.eks. RISK_PROFILE",
    syncKeyDescription:
      "Identifikator en integrasjon bruker for dette feltet i det offentlige API-et. Må være unik i flyten.",
    syncKeyInUse: "Synkroniseringsnøkkelen brukes allerede av et annet felt i denne flyten",
    optionModeLabel: "Tekst",
    optionModeSyncKey: "Synk.nøkkel",
    optionModeAria: "Rediger tekst eller synkroniseringsnøkler for alternativene",
    optionSyncKeyDisabled:
      "Gi feltet en synkroniseringsnøkkel først — alternativer kan bare ha nøkler når feltet har det",
    optionSyncKeyPlaceholder: "f.eks. HIGH",
    optionSyncKeyAria: "synkroniseringsnøkkel",
    optionSyncKeyDescription:
      "Identifikator en integrasjon kan sende i stedet for alternativets id. Må være unik i feltet.",
    optionSyncKeyInUse: "Et annet alternativ i dette feltet bruker allerede denne nøkkelen",
    optionSyncKeysDropped:
      "Feltet har ingen synkroniseringsnøkkel, så alternativenes nøkler fjernes når du lagrer.",
    cancel: "Avbryt",
    save: "Lagre",
    addField: "Legg til felt",
  },
} as const;
